import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';

export default function Details() { 
    const { id } = useParams();
    const [ user, setUser ] = useState([]);

    useEffect(() => { 
        axios.post('http://localhost:5000/GetUser', { id: id })
            .then((response) => { 
                setUser(response.data);
            
            })
            .catch((error) => { 
                console.log(error);
            });
    });

    useEffect(() => { 
        axios.get('http://localhost:5000/GetUser', { id: id })
            .then((response) => { 
                setUser(response.data);
                console.log(response.data);
            })
            .catch((error) => { 
                console.log(error);
            });
    }, [user]);

    return(
        <React.Fragment>
            <h1>User Details</h1>

            <main>
            <dl>
                <dt>First Name:</dt>
                <dd>{user.firstName}</dd>
            </dl>
            </main>
        </React.Fragment>
    )
}